import { render } from "./forgot-reset-pin.vue?vue&type=template&id=286e2e30"
import script from "./forgot-reset-pin.vue?vue&type=script&lang=js"
export * from "./forgot-reset-pin.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__